'use client';

import Link from 'next/link';

import { useTranslations } from '@/components/language-provider';

export function AppFooter() {
  const { messages } = useTranslations();

  return (
    <footer className="mt-20 border-t border-border/80 bg-surface py-10 text-sm text-muted-foreground">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 md:flex-row md:items-center md:justify-between md:px-6">
        <div className="space-y-2">
          <p className="text-base font-semibold text-foreground">WhoPlays US</p>
          <p>{messages.footer.tagline}</p>
          <p className="text-xs">&copy; {new Date().getFullYear()} WhoPlays US · {messages.footer.rights}</p>
        </div>
        <div className="flex flex-wrap items-center gap-4 font-medium text-foreground">
          <Link href="/subscription-plans" className="transition hover:text-primary hover:underline">
            {messages.footer.links.plans}
          </Link>
          <Link href="/privacy-policy" className="transition hover:text-primary hover:underline">
            {messages.footer.links.privacy}
          </Link>
          <Link href="/userdeletion" className="transition hover:text-primary hover:underline">
            {messages.footer.links.accountDeletion}
          </Link>
        </div>
      </div>
    </footer>
  );
}
